module.exports = __webpack_public_path__ + "img/ifortaleza-logo.7d488ee0.svg";